<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Somewhat Dissatisfied Filled" class="d-icon d-icon--somewhat-dissatisfied-filled" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M.563 6a5.437 5.437 0 1 1 10.874 0A5.437 5.437 0 0 1 .563 6Zm3.5-1.5c0-.242.195-.438.437-.438h.005a.437.437 0 1 1 0 .875H4.5a.437.437 0 0 1-.438-.437Zm3 0c0-.242.195-.438.437-.438h.005a.437.437 0 1 1 0 .875H7.5a.437.437 0 0 1-.438-.437Zm-1.84 2.938c-.37 0-.73.121-1.025.346l-.082.064a.438.438 0 0 1-.532-.696l.083-.063a2.563 2.563 0 0 1 1.556-.527h1.508c.598 0 1.178.21 1.638.593l.01.009a.437.437 0 1 1-.559.672l-.01-.008a1.688 1.688 0 0 0-1.08-.39H5.225Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconSomewhatDissatisfiedFilled',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
